export const POS_MODULE_NAVIGATION_MESSAGE = 'POS.MODULE.NAVIGATION';

export type PosModuleNavigationMessage = {
  message: string;
  senderModule: string;
  targetModule: string;
  targetPath?: string;
  query?: string;
};

export const createModuleNavigationMessage = (
  senderModule: string,
  targetModule: string,
  targetPath?: string,
  query?: string
): PosModuleNavigationMessage => {
  return {
    message: POS_MODULE_NAVIGATION_MESSAGE,
    senderModule: senderModule,
    targetModule: targetModule,
    targetPath: targetPath,
    query: query,
  };
};
